import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';
import { ModuleStatus } from './ModuleCard';

interface SummaryCardProps {
  modules: ModuleStatus[];
}

const SummaryCard: React.FC<SummaryCardProps> = ({ modules }) => {
  const workingModules = modules.filter(m => m.status === 'working').length;
  const partialModules = modules.filter(m => m.status === 'partial').length;
  const totalModules = modules.length;
  const averageProgress = Math.round(modules.reduce((sum, m) => sum + m.progress, 0) / modules.length);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <TrendingUp className="mr-2 h-5 w-5" />
          Общее состояние системы ARENDAPRO+
        </CardTitle>
        <CardDescription>
          Полный анализ функциональности системы управления арендой
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="text-center">
            <div className="text-3xl font-bold text-green-600">{workingModules}</div>
            <div className="text-sm text-gray-600">Полностью работают</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-yellow-600">{partialModules}</div>
            <div className="text-sm text-gray-600">Частично работают</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-blue-600">{totalModules}</div>
            <div className="text-sm text-gray-600">Всего модулей</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-purple-600">{averageProgress}%</div>
            <div className="text-sm text-gray-600">Средняя готовность</div>
          </div>
        </div>
        
        <div className="w-full bg-gray-200 rounded-full h-3 mb-4">
          <div 
            className="bg-gradient-to-r from-green-500 to-blue-500 h-3 rounded-full transition-all duration-500" 
            style={{ width: `${averageProgress}%` }}
          ></div>
        </div>
        
        <div className="p-4 bg-green-50 rounded-lg border border-green-200">
          <h3 className="font-semibold text-green-800 mb-2">🎉 Статус проекта: ГОТОВ К ПРОДУКТИВНОМУ ИСПОЛЬЗОВАНИЮ</h3>
          <p className="text-green-700 text-sm">
            Система полностью функциональна для управления арендным бизнесом. 
            {workingModules} из {totalModules} модулей работают стабильно. 
            Средняя готовность системы составляет {averageProgress}%.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default SummaryCard;
